// Corrected EditSubscriptions
// Added submit button inside the form
import React, { useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const EditSubscriptions = ({ userData = {}, onUpdate, onFieldChange }) => {
  const [openIndex, setOpenIndex] = useState(null);



  // Subscription options configuration
  const subscriptionOptions = {
    emailNotifications: {
      mainCategories: [
        { label: "Labnext Newsletter", field: "newsletter" },
        { label: "Labnext Daily Summary", field: "dailySummary" },
        { label: "Labnext Activity Log", field: "activityLog" },
        { label: "Cases Created, by the Account", field: "casesCreatedByAccount" },
        { label: "Cases Created, by the Lab", field: "casesCreatedByLab" },
        { label: "Pickup Requests", field: "pickupRequests" },
        { label: "Balance Payments", field: "balancePayments" },
        { label: "Statements", field: "statements" },
        { label: "Invoices", field: "invoices" },
        { label: "Processes", field: "processes" },
        { label: "Accounts", field: "accounts" },
        { label: "Account Changes by Account", field: "accountChangedByAccount" },
        { label: "Account Changes by Lab", field: "accountChangedByLab" },
        { label: "Cases Changed", field: "casesChangedByAccount" },
      ],
      subCategories: [
        {
          title: "Cases changed, by the Account",
          field: "casesChangedByAccount",
          items: [
            { label: "Procedures Changed", field: "proceduresChangedByAccount" },
            { label: "Delivery Date Rescheduled", field: "deliveryDateRescheduledByAccount" },
            { label: "Patient Changed", field: "patientChangedByAccount" },
            { label: "On Hold With Proposal Status Changed", field: "onHoldWithProposalStatusChangedByAccount" },
            { label: "Files Changed", field: "filesChangedByAccount" },
            { label: "Case Canceled", field: "caseCanceledByAccount" },
            { label: "Note Added", field: "noteAddedByAccount" },
          ],
        },
        {
          title: "Cases changed, by the Lab",
          field: "casesChangedByLab",
          items: [
            { label: "Procedures Changed", field: "proceduresChangedByLab" },
            { label: "Delivery Date Rescheduled", field: "deliveryDateRescheduledByLab" },
            { label: "Patient Changed", field: "patientChangedByLab" },
            { label: "Account Changed", field: "accountChangedByLab" },
            { label: "Provider Changed", field: "providerChangedByLab" },
            { label: "On Hold Status Changed", field: "onHoldWithProposalStatusChangedByLab" },
            { label: "Case Arrived/Received By The Lab", field: "caseArrivedReceivedByLabByLab" },
            { label: "Components Changed", field: "componentsChangedByLab" },
            { label: "Files Changed", field: "filesChangedByLab" },
            { label: "Case Canceled", field: "caseCanceledByLab" },
            { label: "Case Closed", field: "caseClosedByLab" },
            { label: "Case Plan/Estimate Changed", field: "casePlanEstimateChangedByLab" },
            { label: "Note Added", field: "noteAddedByLab" },
          ],
        },
      ],
    },
  };

  const handleCheckboxChange = (fieldType, fieldName, checked) => {
    onFieldChange(fieldType, fieldName, checked);
  };

  const toggleDropdown = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const success = await onUpdate({
      email: userData.email,
      emailNotifications: userData.emailNotifications || {}
    });
    if (success) {
      toast.success("Subscriptions updated successfully!", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        closeButton: true,
      });
    }
  };

  const email = userData.email || "info@hiradentallab.com"; // Fallback email
  const emailNotifications = userData.emailNotifications || {};

  return (
    <div style={{ width: "120%",maxWidth:"1800px", margin: "0 auto", padding: "0px" }}>
      <div className="row">
        <div className="col-md-10">
          <div>
            <h1 >Email Subscriptions</h1>
            <form onSubmit={handleSubmit}>
              <div
                className="Email"
                style={{
                  border: "1px solid #f8f9fa",
                  borderTop: "3px solid #004aad",
                  backgroundColor: "#e9ecef",
                  padding:"20px"
                }}
              >
                <p style={{ marginBottom: "20px" }}>
                  {email
                    ? `Subscriptions will be sent to: ${email}`
                    : "This user does not have an email address. Subscriptions will be sent to the preferred email address: info@hiradentallab.com"}
                </p>

                {/* Main Categories */}
                {subscriptionOptions.emailNotifications.mainCategories.map((item, index) => (
                  <div
                    key={index}
                    className={`form-check ${index >= 3 ? "indented-label" : ""}`}
                    style={{ marginLeft: index >= 3 ? "20px" : "0" }}
                  >
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={`email-${item.field}`}
                      checked={emailNotifications[item.field] || false}
                      onChange={(e) => handleCheckboxChange(
                        'emailNotifications',
                        item.field,
                        e.target.checked
                      )}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`email-${item.field}`}
                      style={{ fontWeight: index < 3 ? "bold" : "normal" }}
                    >
                      {item.label}
                    </label>
                  </div>
                ))}
                <br />

                {/* Sub Categories */}
                {subscriptionOptions.emailNotifications.subCategories.map((category, index) => (
                  <div key={index} style={{ marginLeft: "20px" }}>
                    <button
                      type="button"
                      onClick={() => toggleDropdown(index)}
                      style={{
                        background: "none",
                        border: "none",
                        color: "#004aad",
                        cursor: "pointer",
                        padding: "5px 0",
                        textAlign: "left"
                      }}
                    >
                      {openIndex === index ? "−" : "+"} {category.title}
                    </button>
                    <br />
                    {openIndex === index && (
                      <div style={{ marginLeft: "20px", marginTop: "10px" }}>
                        {category.items.map((subItem, subIndex) => (
                          <div key={subIndex} style={{ marginBottom: "5px" }}>
                            <input
                              type="checkbox"
                              id={`email-${subItem.field}`}
                              checked={emailNotifications[subItem.field] || false}
                              onChange={(e) => handleCheckboxChange(
                                'emailNotifications',
                                subItem.field,
                                e.target.checked
                              )}
                            />
                            <label
                              htmlFor={`email-${subItem.field}`}
                              style={{ marginLeft: "5px" }}
                            >
                              {subItem.label}
                            </label>
                          </div>
                        ))}
                      </div>
                    )}
                    <br />
                  </div>
                ))}
              </div>
              <div style={{ textAlign: "right", marginTop: "10px" }}>
                <button 
                  type="submit" 
                  style={{ backgroundColor: "#004aad", color: "#fff", border: 'none', padding: "8px 16px", borderRadius: "4px" }}
                >
                  Save Subscriptions
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditSubscriptions;